<template>
  <div class="section">
    <h2 class="concert-list-title">
      {{ $t('concertsList.conciertosDe') }} {{ name }}
    </h2>
    <div class="separator" />
    <ul v-if="eventsList && eventsList.events && eventsList.events.length > 0"
        id="events-list"
        ref="events-list"
        class="events-list">
      <li v-for="(element, index) in eventsList.events"
          v-show="index < limit"
          :key="element.id"
          class="animate__animated animate__fadeInUp"
          itemscope
          itemtype="http://schema.org/MusicEvent">
        <time :datetime="getDate(element.attendance, element.start_date).format('YYYY-MM-DDTHH:mm:ssZ')"
              itemprop="startDate"
              class="event-start-time">
          {{ getDate(element.attendance, element.start_date).format('DD MMM YYYY') }}
        </time>
        <time v-if="element.end_date && element.type === 1"
              :datetime="getDate(element.attendance, element.end_date).format('YYYY-MM-DDTHH:mm:ssZ')"
              itemprop="endDate">
          -
          {{ getDate(element.attendance, element.end_date).format('DD MMM YYYY') }}
        </time>
        <time v-else
              :datetime="getDate(element.attendance, element.start_date).add(4, 'hours')
                  .format('YYYY-MM-DDTHH:mm:ssZ')"
              itemprop="endDate"></time>
        <div class="container-event">
          <div class="container-left">
            <!-- <router-link :to="
                element.permalink
                  | permalinkfilter($store.state.initial.detail.wegow_direct)
              "
                       :title="element.title"
                       class="image-link"
                       itemprop="url"> -->
            <a 
              :title="element.title"
              class="image-link"
              itemprop="url"
              :href="element.permalink" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <img :src="getImage(element.thumbnails)"
                   :alt="element.title | removeQuotes"
                   class="lazyload"
                   itemprop="image"
                   @error="
                  $event.target.src = require('@/assets/images/placeholder-event.svg')
                " />
            </a>
            <div class="container-info">
              <!-- <router-link :to="
                  element.permalink
                    | permalinkfilter($store.state.initial.detail.wegow_direct)
                "
                  :title="element.title"
                  class="event-title"> -->
              <a 
                :title="element.title"
                class="event-title"
                :href="element.permalink" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <span itemprop="name">{{ element.title }}</span>
              </a>
              <meta :content="element.description"
                    itemprop="description" />
              <meta itemprop="eventStatus"
                    itemscope=""
                    :itemtype="getEventStatus(element.cancelation_status)" />
              <meta itemprop="eventAttendanceMode"
                    itemscope=""
                    :itemtype="element.attendance !== 2 ? 'https://schema.org/OfflineEventAttendanceMode' : 'https://schema.org/OnlineEventAttendanceMode'" />
              <div itemprop="location"
                   itemscope=""
                   itemtype="http://schema.org/MusicVenue"
                   class="container-info-item">
                <!-- <router-link v-if="element.venue"
                           :to="
                    element.venue.permalink
                      | permalinkfilter(
                        $store.state.initial.detail.wegow_direct
                      )
                  "
                           itemprop="sameAs"
                           class="venue-name"> -->
                <a
                  v-if="element.venue" 
                  class="venue-name"
                  itemprop="sameAs"
                  :href="element.venue.permalink" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <span v-if="element.venue"
                        itemprop="name">
                    {{ element.venue.name }}
                  </span>
                  -
                  <span v-if="element.city">{{ element.city.name }}</span>
                </a>
                <meta v-if="element.venue && element.venue.address"
                      :content="element.venue.address"
                      itemprop="address" />
                <meta v-else
                      :content="element.city.name"
                      itemprop="address" />
              </div>
              <div v-if="element.show_time !== false"
                   class="container-info-item">
                <time class="time">
                  {{ getDate(element.attendance, element.start_date).format('HH:mm') }}
                  h
                </time>
              </div>
              <div v-if="(element.attendance === 2 || element.attendance === 3) && channels[`channel-${element.id}`]"
                   class="container-info-item">
                <a v-for="channel in channels[`channel-${element.id}`]"
                   :key="channel.id"
                   :href="channel.url"
                   target="_blank">
                  <img class="channel-image"
                       :src="channel.provider.image" />
                </a>
              </div>
            </div>
          </div>
          <div v-if="element.artists && element.artists.length > 0"
               itemtype="http://schema.org/PerformingGroup"
               style="display: none;">
            <meta v-for="artist in element.artists"
                  :key="artist.id"
                  :content="artist.name"
                  itemprop="name" />
          </div>
          <div class="event-price-buy"
               itemprop="offers"
               itemscope=""
               itemtype="http://schema.org/Offer">
            <meta :content="element.price"
                  itemprop="price" />
            <meta v-if="element.currency"
                  :content="element.currency"
                  itemprop="priceCurrency" />
            <link itemprop="availability"
                  href="http://schema.org/InStock" />
            <link :href="element.permalink"
                  itemprop="url" />
            <meta :content="element.created"
                  itemprop="validFrom" />
            <div class="container-price">
              <p v-if="
                  element.price && element.currency && element.price !== '0.00'
                "
                 class="event-price">
                {{ $t('concertsList.desde') }}
                <span v-if="element.currency">
                  {{
                    $n(element.price, {
                      key: 'currency',
                      currency: element.currency,
                    })
                  }}
                </span>
              </p>
              <div />
              <!-- <router-link v-if="
                  element.purchase_url &&
                  (element.has_sales || element.has_options)
                "
                         :to="
                  element.purchase_url
                    | permalinkfilter($store.state.initial.detail.wegow_direct)
                "
                         class="btn opacity"> -->
                <a
                  v-if="element.purchase_url && (element.has_sales || element.has_options)" 
                  class="btn opacity"
                  :href="element.purchase_url" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >  
                {{ $t('concertsList.comprar') }}
              </a>
              <a v-if="element.attendance === 2 && defaults[`channel-${element.id}`] && defaults[`channel-${element.id}`][0]"
                 :href="defaults[`channel-${element.id}`][0].url"
                 target="_blank"
                 class="btn transparent">
                {{ $t('concertsList.verStreaming') }}
              </a>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div v-if="
        eventsList && eventsList.events && eventsList.events.length >= limit
      "
         :class="{
        'arrow-up': limit === eventsList.events.length,
        'arrow-down': limit < eventsList.events.length,
      }"
         class="events-list-get-more">
      <p v-if="limit < eventsList.events.length"
         @click="getMore">
        {{ $t('concertsList.verMasConciertos') }}
      </p>
      <p v-else-if="
          limit === eventsList.events.length &&
          ((!isMobile && limitTo < eventsList.events.length) ||
            (isMobile &&
              limitToMobile < eventsList.events.length))
        "
         @click="getLess">
        {{ $t('concertsList.verMenosConciertos') }}
      </p>
    </div>
    <div v-if="eventsList && eventsList.events && eventsList.events.length === 0"
         class="no-concerts">
      <p v-if="type === 'artist'"
         class="disInlB">
        {{
          $t(
            'concertsList.sigueAEsteArtistaYCuandoTengaConciertosTeLoNotificaremos'
          )
        }}
      </p>
      <p v-else-if="type === 'venue'"
         class="disInlB">
        {{
          $t(
            'concertsList.sigueAEstaSalaYCuandoTengaConciertosTeLoNotificaremos'
          )
        }}
      </p>
      <p v-else-if="type === 'company'"
         class="disInlB">
        {{
          $t(
            'concertsList.sigueAEstePerfilOficialYCuandoTengaConciertosTeLoNotificaremos'
          )
        }}
      </p>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    user: {
      type: Object,
      default: () => {},
    },
    elementId: {
      type: Number,
      default: undefined,
    },
  },
  data: () => ({
    limitTo: 5,
    limitToMobile: 3,
    limit: 0,
    channels: [],
    defaults: [],
  }),
  computed: {
    eventsList() {
      return this.$store.state.company.detail
    },
    isMobile() {
      if (
        /Android|webOS|iPhone||iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true
      } else {
        return false
      }
    },
  },
  mounted() {
    this.limit =
      this.isMobile ? this.limitTo : this.limitToMobile
  },
  methods: {
    getEventStatus(cancelation_status) {
      if (cancelation_status === 0) {
        return 'https://schema.org/EventScheduled'
      } else if (cancelation_status === 1) {
        return 'https://schema.org/EventCancelled'
      } else if (cancelation_status === 2) {
        return 'https://schema.org/EventPostponed'
      } else if (cancelation_status === 3) {
        return 'https://schema.org/EventRescheduled'
      }
      return undefined
    },
    getMore() {
      this.limit = this.eventsList.events.length
    },
    getLess() {
      var element = this.$refs['events-list'],
        options = {
          offset: -150,
        }
      this.limit =
        this.isMobile() ? this.limitTo : this.limitToMobile
      this.$scrollTo(element, 500, options)
    },
    getDate(attendance, date) {
      if (!date) return this.$moment();

      if (attendance === 2 || attendance === 3) {
        return this.$moment(date)
      }
    
      return this.$moment(date).utc()
    },
    getImage(thumbnails) {
      if (thumbnails && thumbnails.s_sq) return thumbnails.s_sq
      else if (thumbnails && thumbnails.s_cd) return thumbnails.s_cd
      return require('@/assets/images/placeholder-event.svg')
    },
  },
}
</script>
<style lang="scss">
@import './concerts-list.sass'
</style>
